import axiosInstance from 'utils/axios';

export default async function checkHotelInvoice() {
    try {
        const res = await axiosInstance.get('/api/prv/member-invoices', {
            params: { 
                packageType: 'hotel',
                statuses: ['pending', 'paid'],
            },
        });

        const pendingHotelInvoice = res.data.find(
            (inv) => inv.status.value === 'pending',
        );

        const paidHotelInvoice = res.data.filter(
            (inv) => inv.status.value === 'paid',
        );

        return { pendingHotelInvoice, paidHotelInvoice };
    } catch (err) {
        return null;
    }
}
